import gql from "graphql-tag";

export const ActivateUser = gql`
  mutation activateUser($input: ActivateUserInput!) {
    ActivateUser(input: $input) {
      clientMutationId
    }
  }
`;

export const DeactivateUser = gql`
  mutation deactivateUser($input: DeactivateUserInput!) {
    DeactivateUser(input: $input) {
      clientMutationId
    }
  }
`;

export const DeclineUser = gql`
  mutation declineUser($input: DeclineUserInput!) {
    DeclineUser(input: $input) {
      clientMutationId
    }
  }
`;

export const InviteUsers = gql`
  mutation inviteUsers($input: InviteUsersInput!) {
    InviteUsers(input: $input) {
      clientMutationId
    }
  }
`;

export const DeleteUser = gql`
  mutation deleteUser($input: DeleteUserInput!) {
    DeleteUser(input: $input) {
      clientMutationId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/user_management/ChangeUserStatus.js